import React from 'react'

const MoveIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size ?? 20} height={props?.size ?? 20} viewBox="0 0 20 20" fill="none">
            <path d="M16.25 10.0026L12.0833 5.83594M16.25 10.0026L12.0833 14.1693M16.25 10.0026H7.91667C6.52777 10.0026 3.75 10.8359 3.75 14.1693" stroke="#222222" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default MoveIcon